import React, { useContext, useEffect, lazy } from 'react'

import { Box } from '@mui/material'

import { QueueSocket } from '../../routes'

import api from '../../api';
import { getSession, getOrCreateAssistantTabId } from '../../auth';

import './styles.css'
import Loading from '../Loading';

const KwikAssistant = ({ closeAssistant }) => {

    const { setShowAssistant } = useContext(QueueSocket)

    const setJS = () => {
        const script = document.createElement('script');
        const bucket = 'https://cf-templates-bum1ctwi7lwa-us-east-1.s3.amazonaws.com'

        let version = 'kwik-assistant-dev.js'
        if (window.location.href.indexOf('kwik.app.br') !== -1)
            version = 'kwik-assistant.js'

        script.src = `${bucket}/${version}`;
        
        // Use isso como exemplo , caso queira carregar a versão de desenvolvimento do Kwik Assistant
        // script.src = 'https://scout.dev07.instantsandbox.net/static/js/kwik-assistant-dev.js'

        script.async = true;

        document.body.appendChild(script);
    }

    const login = async () => {
        const user = getSession();

        // Stable id for the full-tab Cortex conversation, kept for the whole
        // login session regardless of ticket switching (see auth.js)
        window.assistantPersistentExternalId = getOrCreateAssistantTabId()

        // Get assistant token
        if ( user && user.profile && user.profile.enterprise.has_assistant && user.profile.has_assistant) {
            const agentId = user.profile.agent.id;
            const res = await api.post(`/api/IV/agents/${agentId}/assistant_login/`)
            if (res.status == 200) {
                window.assistantAccessToken = res.data['access_token']
                window.assistantAccountCode = user.profile.enterprise.assistant_accountcode_id
                window.assistantUserId = user.profile.assistant_user_id
                window.assistantUrl = res.data['assistant_url']
                window.streamMode = user.profile.stream_mode
            }
            else
                console.error('Couldnt login agent assistant [err:%o]', res.err)
        }
        setJS()
    }

    useEffect(() => {
        window.closeAssistant = (() => (closeAssistant) ? closeAssistant() : setShowAssistant(false))
        login()
    }, [])

    return (
        <>
            <Box sx={{ flex: .25 }} id='assistant-container-vpower'>
                <Loading loading={true} nofixed />
            </Box>
        </>
    )
}

export default KwikAssistant
